import { render, staticRenderFns } from "./RequestTypesGrid.vue?vue&type=template&id=f0060c7a"
import script from "./RequestTypesGrid.vue?vue&type=script&lang=js"
export * from "./RequestTypesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports